module.exports = __webpack_public_path__ + "img/bg-i.4d2bea1d.png";